export const version = '1.2.3';
//# sourceMappingURL=version.js.map